import React from "react";
import PropTypes from "prop-types";
import { useSocialLinks } from "../../utils/menuLinks";
import styled from "styled-components";
import breakpoints from "../../utils/breakpoints";

const StyledContainer = styled.div`
  .social-media {
      height: auto;
      margin-left: 20px; 
      padding-bottom: 80px;
      display: flex;
      flex-direction: column;
      align-items: start;
      gap: 20px;
      ${breakpoints.medium`
        margin-left: 0;
        padding-bottom: 0;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 7px;
        `}
      }
        
    .line {
      width: 120px;
      border-top: 1px solid  white;
      margin-top: 20px;
      margin-bottom: 10px;
      ${breakpoints.medium`
        width: 1px;
        height: 24px;
        border: none;
        border-left: 1px solid white;
        margin-top: 0;
        margin-right: 10px;
        margin-bottom: 0;
        `}
    }

   .social-media-icon {
    text-decoration: none;
    display: flex;
    transition: all 0.3s;
    &:hover {
      text-decoration: underline;
    }
   }

  .social-media-text {
      font-size: 16px;
      padding-left: 4px;
      ${breakpoints.medium`
        display: none;
      `}
  }
`;

const SocialLinks = ({ backgroundColor, closeMenu }) => {
    const socialLinks = useSocialLinks();


  return (
    <StyledContainer>
        <div className="social-media">
        <span className="line"></span>
        {socialLinks.map(({ href, icon, name }) => (
            <a
            key={name}
            href={href}
            className={`color--salmon__300 social-media-icon`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMenu}
            aria-label={`Abrir en ${name}`}
            role="link"
            >
            {icon} <span className={`social-media-text`}>{name}</span>
            </a>
        ))}
        </div>
    </StyledContainer>
  );
};

SocialLinks.propTypes = {
  backgroundColor: PropTypes.string,
  closeMenu: PropTypes.func
};

export default SocialLinks;
